import requests from "./httpService";

const CashCategoryServices = {
  createCashCategory: async (body) => {
    return requests.post("/cash-categories", body);
  },

  getCashCategories: async (status = "", cashType = "") => {
    const params = new URLSearchParams();

    if (status) params.set("status", status);
    if (cashType) params.set("cashType", cashType);

    const query = params.toString();

    return requests.get(
      `/cash-categories${query ? `?${query}` : ""}`
    );
  }
};

export default CashCategoryServices;